/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
    return /^(https?:|mailto:|tel:)/.test(path)
}



// 页面功能公共方法
/**
 * 页面提交防抖F
 */
export const antiShake = (fn, t, no_message = false) => {
    const delay = t || 500
    let timer
    // eslint-disable-next-line no-unused-vars
    return function(val, val1) {
        const args = arguments
        if (timer) {
            if (!no_message) {
                this.$message({
                    showClose: true,
                    message: '请勿在' + t / 1000 + '秒内多次点击！',
                    type: 'warning'
                })
            }
            clearTimeout(timer)
        }
        const callNow = !timer
        timer = setTimeout(() => {
            timer = null
        }, delay)
        if (callNow) fn.apply(this, args)
    }
}

/**
 * 深拷贝
 */
export function deepClone(obj, hash = new WeakMap()) {
    if (hash.has(obj)) {
        return obj
    }
    let res = null
    const reference = [Date, RegExp, Set, WeakSet, Map, WeakMap, Error]

    if ((obj && obj.constructor) && (reference.includes(obj.constructor))) {
        res = new obj.constructor(obj)
    } else if (Array.isArray(obj)) {
        res = []
        obj.forEach((e, i) => {
            res[i] = deepClone(e)
        })
    } else if (typeof obj === 'object' && obj !== null) {
        res = {}
        for (const key in obj) {
            if (Object.hasOwnProperty.call(obj, key)) {
                res[key] = deepClone(obj[key])
            }
        }
        hash.set(obj, res)
    } else {
        res = obj
    }
    return res
}
